import React from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
import AppRoute from "./AppRoute.js";
import { BrowserRouter } from "react-router-dom"; // New line
import { MaterialUIControllerProvider } from "context";

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
  <MaterialUIControllerProvider>
    <BrowserRouter>
      <AppRoute />
    </BrowserRouter>
  </MaterialUIControllerProvider>
);
